<template lang="html">
  <div class="page-login" v-if="loaded">
    <Notification
      v-if="notification.active"
      :withinOverlay="true"
      :content="notification.content"
      :type="notification.type"
    />

    <LoginForm
      v-model="user"
      :errors="errors"
      :accountActivated="accountActivated"
      :passwordReset="passwordReset"
      :inviteSent="inviteSent"
      @submit="login"
    />
  </div>
</template>

<script>
import LoginForm from '@/components/forms/LoginForm'
import notification from '@/mixins/notification'

import {mapState, mapActions, mapGetters} from 'vuex'

export default {
  name: 'login',

  mixins: [notification],

  components: {
    LoginForm
  },

  data() {
    return {
      user: {},
      errors: {},
      loaded: false
    }
  },

  mounted() {
    if (this.session.token) {
      this.$router.push({
        name: 'websites',
        params: {companyId: this.currentCompanyId}
      })
    } else {
      this.loaded = true
    }
  },

  computed: {
    ...mapGetters(['currentUserId', 'currentCompanyId']),
    ...mapState(['session']),

    accountActivated() {
      return this.$route.query.activated
    },

    passwordReset() {
      return this.$route.query.passwordReset
    },

    inviteSent() {
      return this.$route.query.inviteSent
    },

    returnQuery() {
      let query = this.$route.query.returnPath
      return query !== '/login' ? query : false
    }
  },

  methods: {
    ...mapActions(['loginUser']),

    login() {
      this.loginUser(this.user)
        .then((response) => {
          if (response) {
            this.triggerNotification('unsuccessful', 'login', 'invalid details')
          } else {
            if (this.returnQuery) {
              // redirect user to previously requested route
              this.$router.push({path: this.returnQuery})
            } else if (this.currentCompanyId) {
              // company users go to their company
              this.$router.push({
                name: 'websites',
                params: {companyId: this.currentCompanyId}
              })
            } else {
              // assume admin user... 401 from api will cause any non admin users
              // to be ousted.
              this.$router.push({
                name: 'companies'
              })
            }
          }
        })
        .catch(({response}) => {
          this.errors = response.errors
        })
    }
  }
}
</script>

<style lang="sass">
@import '../stylesheets/base/variables'
@import '../stylesheets/base/theme'
@import '../stylesheets/helpers/mixins'
@import '../stylesheets/helpers/extends'

.page-login
  display: flex
  flex-direction: row
  width: 100%
  align-items: center
  height: calc(100vh - #{$header-height})

  @include themify($themes)
    background: themed('color-secondary')

  h1
    text-align: center
</style>
